import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaBookOpen } from 'react-icons/fa';
import { FaClipboardList } from 'react-icons/fa';

import {
  FaHome,
  FaUserPlus,
  FaMoneyBill,
  FaListUl,
  FaWallet,
  FaCertificate,
  FaChalkboardTeacher,
  FaUser,
  FaSignOutAlt,
  FaUniversity,
  FaHistory,
  FaExchangeAlt,
  FaBars,
  FaTimes
} from 'react-icons/fa';
import '../styles/Dashboard.css';
import { SCHOOL_SHORT_NAME } from '../config/school';

const NAV_ITEMS = [
  { to: '/home', icon: <FaHome />, label: 'Home' },
  { to: '/add-new-student', icon: <FaUserPlus />, label: 'Add Student' },
  { to: '/fee-payment', icon: <FaMoneyBill />, label: 'Fee Payment' },
  { to: '/student-payment-list', icon: <FaListUl />, label: 'Payment List' },
  { to: '/miscellaneous-expenses', icon: <FaWallet />, label: 'Expenses' },
  { to: '/certificates', icon: <FaCertificate />, label: 'Certificates' },
  { to: '/coaching', icon: <FaChalkboardTeacher />, label: 'Coaching' },
  { to: '/coaching-history', icon: <FaHistory />, label: 'Coaching History' },
  { to: '/coaching-fee-summary', icon: <FaBookOpen />, label: 'Coaching Summary' },
  { to: '/bank-records', icon: <FaUniversity />, label: 'Bank Records' },
  { to: '/collection-history', icon: <FaListUl />, label: 'Collection History' },
  { to: '/records', icon: <FaWallet />, label: 'Bank/Cash Records' },
  { to: '/oldfeesstudent', icon: <FaHistory />, label: 'Old Fees Student' },
  { to: '/meeting-report', icon: <FaClipboardList />, label: 'Meeting Report' },
  { to: '/transaction-history', icon: <FaExchangeAlt />, label: 'Transaction History' },
  { to: '/user-profile', icon: <FaUser />, label: 'Profile' }
];

const Dashboard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLogout = async () => {
    if (window.confirm("Are you sure you want to logout?")) {
      try {
        await axios.get(
          "/backend/api/logout.php",
          { withCredentials: true }
        );
        localStorage.removeItem('userEmail');
        navigate('/login');
        window.location.reload();
      } catch (error) {
        console.error("Logout failed:", error);
        alert("Error logging out. Please try again.");
      }
    }
  };

  return (
    <div className="dashboard-container">
      {/* Mobile top bar */}
      <header className="topbar">
        <button
          className="menu-toggle"
          onClick={() => setIsSidebarOpen(true)}
          aria-label="Open menu"
        >
          <FaBars />
        </button>
        <span className="topbar-title">🎓 {SCHOOL_SHORT_NAME}</span>
      </header>

      {/* Overlay for mobile drawer */}
      <div
        className={`sidebar-overlay ${isSidebarOpen ? 'show' : ''}`}
        onClick={() => setIsSidebarOpen(false)}
      />

      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-top">
          <h2 className="sidebar-header">🎓 {SCHOOL_SHORT_NAME}</h2>
          <button
            className="sidebar-close"
            onClick={() => setIsSidebarOpen(false)}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className={location.pathname === item.to ? 'active' : ''}
                  onClick={() => setIsSidebarOpen(false)}
                >
                  {item.icon} {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="logout-section">
          <button className="logout-button" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </aside>

      <main className="content">
        {children}
      </main>
    </div>
  );
};

export default Dashboard;
